import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomQuickorderExportsModule } from 'src/app/extensions/custom-quickorder/exports/custom-quickorder-exports.module';

import { AppFacade } from 'ish-core/facades/app.facade';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';

@Component({
  selector: 'custom-cms-quick-order-navigation-link',
  templateUrl: './cms-quick-order-navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, FeatureToggleModule, CustomQuickorderExportsModule],
})
export class CmsQuickOrderNavigationLinkComponent implements OnInit, OnDestroy {
  private appfacade = inject(AppFacade);

  readonly pagelet = input<ContentPageletView>(undefined);
  isSticky$: Subscription;
  isSticky = false;
  ngOnInit() {
    this.isSticky$ = this.appfacade.stickyHeader$.subscribe((value: boolean) => {
      this.isSticky = value;
    });
  }
  ngOnDestroy() {
    // Unsubscribe from isSticky$ to avoid memory leaks
    this.isSticky$.unsubscribe();
  }
  manageLeft() {
    if (!SSR) {
      const div = document.getElementById('globalNavigation');
      const quickorderNav = document.getElementById('quickorder-nav');
      if (this.isSticky) {
        document.getElementById('quickorderFlyoutView').style.left = `${
          quickorderNav.getBoundingClientRect().left - div.getBoundingClientRect().left
        }px`;
      } else {
        document.getElementById('quickorderFlyoutView').style.left = `${0}px`;
      }
    }
  }
}
